import Link from "next/link";
import { useSearchParams } from "next/navigation";
import React, { useState } from "react";
import { ImageKit } from "@aph/ui-lib-humanx";
import footerDataInfo from "@/components/footer/footer.json";
import { NEXT_PUBLIC_CDN_URL, NEXT_PUBLIC_MOM_BABY_BASE_PATH } from "@/libs/constants/auth";
import styles from "./Footer.module.scss";

interface FooterUrlInterface {
  url: string;
  title: string;
  rel?: string;
}
interface FooterLinks {
  footerData?: {};
  isMobile?: boolean;
}

const Footer: React.FC<FooterLinks> = (props) => {
  const footerData = footerDataInfo?.data;
  let footerKeys: string[] = [];

  if (footerData) {
    footerKeys = Object.keys(footerData);
  }

  const urlParameters = useSearchParams();
  const [expandedKey, setExpandedKey] = useState<string>("");

  const config = {
    PHARMACY: "Pharmacy",
    MEDICINE: "Medicine",
  };

  const LINKEDIN_LINK = "https://in.linkedin.com/company/apollo247";

  return (
    <footer className={`${styles.footerRoot}`}>
      <div className={"revampedContainer"}>
        <div className={styles.accordionContainer}>
          {footerKeys &&
            footerKeys.map((currentItem: string, index: number) => {
              const key = `${currentItem}-${index}`;
              const open = expandedKey === key;

              return (
                <div className={styles.accordion} key={key}>
                  <div
                    className={styles.accordionHeader}
                    onClick={() => setExpandedKey(expandedKey === key ? "" : key)}
                  >
                    <h2 className={styles.title}>
                      {urlParameters?.get("variant") && currentItem?.includes(config.PHARMACY)
                        ? currentItem.replace(config.PHARMACY, config.MEDICINE)
                        : currentItem}
                    </h2>
                    <span className={`${styles.expandIcon} ${open ? styles.active : ""}`}></span>
                  </div>
                  <div className={`${open ? "" : styles.hide}`}>
                    <ul className={styles.footerLinks}>
                      {footerData[currentItem].map((currentLink: FooterUrlInterface) => {
                        const followRel = currentLink?.url.includes(NEXT_PUBLIC_MOM_BABY_BASE_PATH)
                          ? "noopener"
                          : "noopener noreferrer";

                        return currentLink ? (
                          <li key={currentLink.title}>
                            <a
                              className={styles.innerLinks}
                              href={currentLink.url}
                              target="_blank"
                              aria-label="Footer Link"
                              rel={followRel}
                            >
                              {urlParameters?.get("variant") && currentLink?.title?.includes(config.PHARMACY)
                                ? currentLink.title.replace(config.PHARMACY, config.MEDICINE)
                                : currentLink.title}
                            </a>
                          </li>
                        ) : null;
                      })}
                    </ul>
                  </div>
                </div>
              );
            })}
        </div>
        <div className={styles.footerLinksWrap}>
          <div className={styles.footerLogo}>
            <Link href="/" prefetch={false} aria-label="logo">
              <ImageKit
                src={`${NEXT_PUBLIC_CDN_URL}/images/pharmacy_logo.svg`}
                alt={"Online Doctor Consultation & Medicines"}
                height={60}
                width={80}
              />
            </Link>
          </div>
          <div className={styles.socialLinkContainer}>
            <h2 className={styles.title}>Find us</h2>
            <ul className={styles.socialLink}>
              <li>
                <a
                  href="https://www.facebook.com/ApolloPharmacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <ImageKit
                    width={40}
                    height={40}
                    src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/Facebook_Logo.png`}
                    alt="facebook"
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/ApolloPharmacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <ImageKit
                    width={40}
                    height={40}
                    src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/Twitter_Logo.png`}
                    alt="twitter"
                  />
                </a>
              </li>
              <li>
                <a href={LINKEDIN_LINK} target="_blank" rel="noopener noreferrer" aria-label="Linkedin">
                  <ImageKit
                    width={40}
                    height={40}
                    src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/LinkedIn_Logo.png`}
                    alt="linkedin"
                  />
                </a>
              </li>
              <li className={styles.youtubeIcon}>
                <a
                  href="https://www.youtube.com/user/ApolloPharmacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Youtube"
                >
                  <ImageKit
                    width={40}
                    height={40}
                    src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/Youtube_Logo.png`}
                    alt="youtube"
                  />
                </a>
              </li>
            </ul>
          </div>
          <div className={styles.downloadAppContainer}>
            <h2 className={styles.title}>Get Apollo Mobile App</h2>
            <ul className={styles.appLinks}>
              <li>
                <a
                  href="https://play.google.com/store/apps/details?id=com.apollo.patientapp&amp;hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Google play"
                >
                  <ImageKit
                    width={133}
                    height={40}
                    src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/Play_Store.png`}
                    alt="google play store "
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://apps.apple.com/in/app/apollo-247/id1496740273"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Apple Store"
                >
                  <ImageKit
                    width={133}
                    height={40}
                    src={`${NEXT_PUBLIC_CDN_URL}/images/momverse/App_Store.png`}
                    alt="apply app store "
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
